import Storage from 'good-storage'
import Config from '@/config/index.js'
import Decimal from 'decimal.js'
import dayjs from '@/utils/dayjs.js'
import i18n from '@/language'
// import { showImagePreview } from 'vant'
import WBAppSdk from '@/utils/wb-app-sdk.js'
import { wbToast } from '@/utils/tips.js'

// 根据参数名获取url参数
export function getUrlParamByName(queryName) {
  return currentUrlToParams(window.location.href, queryName)
}

export function currentUrlToParams(link = window.location.href, key = null) {
  var url = decodeURI(link)
  const paramsUrl = url.split('?')
  if (paramsUrl.length < 2) return key ? null : {}
  const paramsArr = paramsUrl[1].split('&')
  const paramsData = {}
  paramsArr.forEach(r => {
    const data = r.split('=')
    paramsData[data[0]] = data[1]
  })
  if (key) return Object.hasOwnProperty.call(paramsData, key) ? paramsData[key] : null
  return paramsData
}

/*
 * 数字转金额格式
 * 参数说明：
 * number：要格式化的数字
 * decimals：保留几位小数
 * dec_point：小数点符号
 * thousands_sep：千分位符号
 * */
export function thousandBitSeparator(number, decimals, dec_point, thousands_sep, fiexdFunc) {
  if (!number) {
    let zero = '0'
    if (decimals > 0) {
      zero += '.'
      for (let i = 0; i < decimals; i++) {
        zero += '0'
      }
    }
    return zero
  } else {
    if (fiexdFunc) {
      number = fiexdFunc(number)
    } else {
      number = numSaveToFloor2(number)
    }
    number = (number + '').replace(/[^0-9+-Ee.]/g, '')
    var n = !isFinite(+number) ? 0 : +number
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
    var sep = typeof thousands_sep === 'undefined' ? ',' : thousands_sep
    var dec = typeof dec_point === 'undefined' ? '.' : dec_point
    var s = ''
    var toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec)
      // return '' + Math.round(n * k) / k
      return '' + (n * k) / k
    }

    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
    var re = /(-?\d+)(\d{3})/
    while (re.test(s[0])) {
      s[0] = s[0].replace(re, '$1' + sep + '$2')
    }

    if ((s[1] || '').length < prec) {
      s[1] = s[1] || ''
      s[1] += new Array(prec - s[1].length + 1).join('0')
    }
    return s.join(dec)
  }
}

export function numSaveToFixed2(number) {
  if (!number) return 0
  if (number === 0) return 0
  let num = Decimal(number).mul(Decimal(100))
  num = num.toNumber()
  // num = Math.floor(num)
  num = Math.round(num) // 四舍五入
  num = Decimal(num).div(Decimal(100))
  num = num.toNumber()
  return num
}

export function numSaveToFloor2(number) {
  if (!number) return 0
  if (number === 0) return 0
  let num = Decimal(number).mul(Decimal(100))
  num = num.toNumber()
  num = Math.floor(num)
  num = Decimal(num).div(Decimal(100))
  num = num.toNumber()
  return num
}

/**
 * 将对象转换为?a=5&b=7形式
 * @param obj
 * @param firstStr
 * @returns {string|string}
 */
export function obj2StrParams(obj, firstStr = '?') {
  let params = firstStr

  for (const p in obj) {
    params += p + '=' + obj[p] + '&'
  }
  return params.substring(0, params.length - 1)
}

/**
 * 重置对象（会修改原始对象）
 * @param object
 * @param defaultVal
 */
export function resetObject(object, defaultVal = {}) {
  for (const k in object) {
    if (Object.hasOwnProperty.call(defaultVal, k)) {
      object[k] = defaultVal[k]
    } else {
      if (Array.isArray(object[k])) object[k] = []
      if (typeof object[k] === 'string') object[k] = ''
      if (typeof object[k] === 'number') object[k] = null
      if (typeof object[k] === 'boolean') object[k] = false
    }
  }
}

/**
 * 对象赋值（会修改原始对象）
 * @param object
 * @param valObject
 */
export function fillerLeft(object, valObject = {}) {
  for (const k in object) {
    if (Object.hasOwnProperty.call(valObject, k)) {
      object[k] = valObject[k]
    }
  }
}

/**
 * 获取用户信息
 * @param key
 * @returns {null|*|undefined|{}}
 */
export function getUserInfo(key = null) {
  const userInfo = Storage.get(Config.userInfoKey) || {}
  if (key) return Object.hasOwnProperty.call(userInfo, key) ? userInfo[key] : null
  return userInfo || {}
}

/**
 * 设置用户信息
 * @param user
 * @returns {*}
 */
export function setUserInfo(user) {
  Storage.set(Config.userInfoKey, user)
  return user
}

/**
 * 获取Token
 * @returns {*|undefined}
 */
export function getToken() {
  return Storage.get(Config.tokenKey)
}

/**
 * 设置Token
 * @param token
 * @returns {*|undefined}
 */
export function setToken(token) {
  return Storage.set(Config.tokenKey, token)
}

/**
 * 移除Token
 * @returns {*}
 */
export function removeToken() {
  return Storage.remove(Config.tokenKey)
}

/**
 * 获取class的高度
 * @param {*} className 
 * @returns 
 */
export function getLineHeightByClass(className) {
  // 获取匹配的第一个元素
  const element = document.querySelector(`.${className}`);
  if (!element) {
    console.error(`未找到class为 ${className} 的元素`);
    return null;
  }

  // 方法1：使用getComputedStyle获取line-height属性
  const style = window.getComputedStyle(element);
  let lineHeight = style.lineHeight;

  // 如果获取到的是具体数值（如"24px"）
  if (lineHeight !== 'normal') {
    return parseFloat(lineHeight);
  }

  // 方法2：通过计算元素高度间接获取行高
  const originalHeight = element.style.height;
  const originalOverflow = element.style.overflow;

  // 临时设置为单行文本
  element.style.height = 'auto';
  element.style.overflow = 'hidden';

  const singleLineHeight = element.offsetHeight;

  // 恢复原始样式
  element.style.height = originalHeight;
  element.style.overflow = originalOverflow;

  return singleLineHeight;
}

// 时间格式化
// 24小时内：N小时前；
// 超过24小时、在72小时内：N天前；
// 超过72小时：展示“YYYY-MM-DD”；
export function getTimeTxt(timeNum) {
  if (!timeNum) {
    return ''
  }
  const thatTime = dayjs(timeNum)
  const nowTime = dayjs()
  const diffMinute = nowTime.diff(thatTime, 'minute')
  if (diffMinute <= 30) {
    // 间隔小于等于30分钟，显示【刚刚】
     return i18n.global.t('article.justNow')
  }
  if (diffMinute < 60) {
    // 间隔小于60分钟
    // return `${diffMinute}${i18n.global.t('article.minuteAgo')}`
    return `1${i18n.global.t('article.hoursAgo')}`
  } else {
    const diffHours = nowTime.diff(thatTime, 'hours')
    if (diffHours < 24) {
      // 间隔小于24小时
      return `${diffHours}${i18n.global.t('article.hoursAgo')}`
    } else if (diffHours < 72) {
      // 间隔小于72小时
      const days = Math.floor(diffHours / 24);
      return `${days}${i18n.global.t('article.daysAgo')}`
    } else {
      return thatTime.format('YYYY-MM-DD')
    }
  }
}

// 时间格式化
// 今天/昨天/MM-DD  HH:MM；
export function getTimeTxt2(timeNum) {
  if (!timeNum) {
    return ''
  }
  const thatTime = dayjs(timeNum)
  const nowTime = dayjs()
  const timeStr = thatTime.format('HH:mm')
  const thatDayStr = thatTime.format('YYYY-MM-DD')
  const todayStr = nowTime.format('YYYY-MM-DD')
  const yesterdayStr = nowTime.subtract(1, 'day').format('YYYY-MM-DD')

  if (thatDayStr === todayStr) {
    return `${i18n.global.t('article.toDay')} ${timeStr}`
  } else if (thatDayStr === yesterdayStr) {
    return `${i18n.global.t('article.yesterday')} ${timeStr}`
  } else {
    return `${thatTime.format('MM-DD')} ${timeStr}`
  }
}

//时间格式化
export function formatTime(value, onlyDayOrTime,xie) {
  if (!value) {
    return '--'
  }
  const now = new Date(value)
  const year = now.getFullYear()
  const month = now.getMonth() + 1
  const day = now.getDate()
  const hour = now.getHours()
  const minute = now.getMinutes()
  const second = now.getSeconds()
  let dates = `${year}-${month > 9 ? month : '0' + month}-${day > 9 ? day : '0' + day}`
  if(xie){
   dates = `${year}/${month > 9 ? month : '0' + month}/${day > 9 ? day : '0' + day}`
  }
  const times = `${hour > 9 ? hour : '0' + hour}:${minute > 9 ? minute : '0' + minute}:${second > 9 ? second : '0' + second}`
  if (onlyDayOrTime == 1) {
    return dates
  } else if (onlyDayOrTime == 2) {
    return times
  }else if (onlyDayOrTime == 3) {
    return `${dates} ${hour > 9 ? hour : '0' + hour}:${minute > 9 ? minute : '0' + minute}`
  }
  return `${dates} ${times}`
}

//数字不为空判断
export function numberNotNull(value){
  // 排除 null 和 undefined
  if (value == null) return false;
  
  // 如果是数字类型，只排除 NaN
  if (typeof value === 'number') return !isNaN(value);
  
  // 如果是字符串，尝试转换为数字
  if (typeof value === 'string') {
    // 排除空字符串或纯空白字符串（可选，根据业务决定）
    if (value.trim() === '') return false;
    const num = Number(value);
    return !isNaN(num);
  }
  
  // 其他类型（布尔、对象等）视为无效
  return false;
}

//数字格式化
export function multiplyAndRound(value, multiplier, decimalPlaces) {
 if (numberNotNull(value)) {
       const result = new Decimal(value).times(multiplier).toFixed(decimalPlaces)
       return result
  }
  return ""
}
 export function globalContentClick(event) {
      const tagName = event.target.tagName
      // if (tagName === 'IMG') {
      //    const srcArr = []
      //    const images = Array.from(document.images)
      //     images.forEach(imgEle => {
      //       if(imgEle.src.includes("http")){//不包含本地图片
      //          srcArr.push(imgEle.src)
      //       }
      //    })
      //   const src = event.target.src
      //   const index = srcArr.findIndex(item => item === src)
      //   if (srcArr.length > 0) {
      //     showImagePreview({
      //       images: srcArr,
      //       startPosition: index || 0
      //     })
      //   }
      // } else 
        if (tagName === 'A') {
        // 注意：event.target.href 会经浏览器 URL 规范化（scheme/host 被转为小写），
        // 例如 /winBull 会变成 /winbull，导致 endsWith('/winBull') 等判断失效。
        // 这里改用 getAttribute('href') 获取 HTML 中原始字符串。
        const href = event.target.getAttribute('href') || ''
        if (href.includes('contactCustomerService/winBull')) {
          //客服
          if (WBAppSdk.inApp){WBAppSdk.openOnlineService()} 
          else wbToast(i18n.global.t('common.pleaseGoAppHandle'))
          event.preventDefault()
        }else if(href.endsWith('/winBull')||href.includes("portfolio_detail/winBull")||href.includes("ThemeDetail/winBull")){//链接最后包含/winBull，或者投资组合或者概念主题通过app跳转
           if (WBAppSdk.inApp) {WBAppSdk.openWebUrl(href)}
           event.preventDefault()
        }

        // const firstMatch = href.match(/\(([^)]*)\)/)
        // const content = firstMatch ? firstMatch[1] : null
        // if (content && (content.includes('.HK') || content.includes('.US'))) {//社区文章的股票
        //   event.preventDefault()
        //   const wbCode = content.includes('.HK') ? content.split('.HK')[0] : content.split('.US')[0]
        //   //股票
        //   if (WBAppSdk.inApp) {
        //     //打开股票详情
        //     WBAppSdk.gotoStockDetail(`${content.includes('.HK') ? 'HK:' : 'US:'}${wbCode}`)
        //   }
        // } 
        // else {//社区文章的超链接
        //   let url = href.split('unsafe:')[1]
        //   if (url) {
        //     if (!url.includes('https')) {
        //       //不支持http，只允许支持https
        //       url = 'https://' + url
        //     }
        //     if (WBAppSdk.inApp) {
        //       //打开网页
        //       WBAppSdk.openWebUrl(url)
        //     } else {
        //       window.location.href = url
        //     }
        //   }
        // }
      }
    }

//定义好的APP跳转链接
// 概念主题：http://ThemeDetail/winBull?topicId=xx&market=US&title=xxx
// 自选    http://appPageWatchLish/winBull
// 市场：港股  http://hkMarket/winBull
// 市场：美股  http://usMarket/winBull
// AI资讯  http://aiInfo/winBull
// 理财  http://invest/winBull
// 日内融  http://dayTrade/winBull
// 美股期权  http://option/winBull  (跳到期权异动首页)
// 涡轮牛熊  http://warrent/winBull
// PI认证  http://piCertification/winBull
// 余额+   http://balance/winBull
// 条件单   http://conditionalOrder/winBull
// ETF   http://etfPage/winBull
// 入金   http://deposit/winBull
// 我的卡券  http://voucher/winBull
// 我的分红  http://dividend/winBull
// 美股财报期权 (跳到期权异动-财报期权)  http://optionsReport/winBull